import { useState, useEffect, useContext } from "react";
import { ResidentDto } from "../../dtos/ResidentDto";
import { CardholderAccessGroupResponse, useManageAccessHttp } from "./useManageAccessHttp";
import { CardholderAccessGroupDto } from "../../dtos/CardholderAccessGroupDto";
import { VillageDto } from "../../dtos/VillageDto";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Box, CircularProgress } from "@mui/material";
import { DisplayConnectionError } from "../../components/DisplayConnectionError";
import VspPortalContext from "../../store/VspPortalContext";
import { getSecurityRoleIds } from "../../utils";
import { UpdateCardholder } from "./UpdateCardholder";


type ManageCommonAreaAccessProps = {

    resident: ResidentDto,
    village: VillageDto

};


export const ManageCommonAreaAccess: React.FC<ManageCommonAreaAccessProps> = ( props: ManageCommonAreaAccessProps ) => {

    const { resident, village } = props;

    const [ cardholderAccessGroups, setCardholderAccessGroups ] = useState<CardholderAccessGroupDto[ ]>( [ ] );
    const [ errorMessage, setErrorMessage ] = useState<string>( '' );
    const [ isLoading, setIsLoading ] = useState<boolean>( false );
    const [ hideVillage, setHideVillage ] = useState<boolean>( false );
    const [ securityRoleIds, setSecurityRoleIds ] = useState<string[ ]>( [ ] );
    
    const { addCardholderAccessGroup, getCardholderCommonAreaAccessGroups, removeCardholderAccessGroup } = useManageAccessHttp( );

    const { state } = useContext( VspPortalContext );


    useEffect( ( ) => {

        if( !resident || !village ) return;

        setCardholderAccessGroups( [ ] );
        setSecurityRoleIds( [ ] );

        const securityRoleIds = getSecurityRoleIds( state.userGroups );
        
        setSecurityRoleIds( securityRoleIds );

        const getAccess = async ( ) => {

            setIsLoading( true );
            const cardholderAccessGroups: CardholderAccessGroupResponse = await getCardholderCommonAreaAccessGroups( resident.employeeId, securityRoleIds, village.villageCode );
            setIsLoading( false );

            setHideVillage( false );

            if( cardholderAccessGroups.cardholderAccessGroupDtos ) {
                
                setErrorMessage( '' );
                setCardholderAccessGroups( cardholderAccessGroups.cardholderAccessGroupDtos );
                

            } else {

                if( cardholderAccessGroups.statusCode === 401 ) {

                    setHideVillage( true );

                } else if( cardholderAccessGroups.statusCode === 404 ) {

                    setErrorMessage( 'Cardholder is not registered at the server' );

                } else {

                    setErrorMessage( 'Error getting data from the server' );

                }

            }

        };

        getAccess( );

    }, [ resident, village ]);


    return (

        <>
            { !hideVillage
                &&
                <>

                    <h3>{ village.villageName }</h3>

                    { 
                        
                        <TableContainer component={ Paper } sx={{ overflowY: 'hidden', width: '50%', marginTop: '10px' }}>
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell width='40%' sx={{ fontWeight: 'bold' }}>Access Group</TableCell>
                                        <TableCell width='30%' sx={{ fontWeight: 'bold' }}>Is Active</TableCell>
                                        <TableCell width='30%' sx={{ fontWeight: 'bold', width: '500px' }}>Expiry</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {

                                        isLoading 
                                            ?
                                        <TableRow>
                                            <TableCell colSpan={ 3 } align='center'>
                                                <CircularProgress size="40px" sx={{color: '#e65400'}}/>
                                            </TableCell>
                                        </TableRow>    
                                            :
                                        cardholderAccessGroups.map( cardholderAccessGroup => 
                                            
                                            <UpdateCardholder 
                                                key={village.villageCode + cardholderAccessGroup.accessGroup}
                                                attribute={cardholderAccessGroup.accessGroup}
                                                expiry={cardholderAccessGroup.until}
                                                isActive={cardholderAccessGroup.isActive}
                                                resident={resident}
                                                securityRoleIds={ securityRoleIds }
                                                title={ cardholderAccessGroup.accessGroup }
                                                village={ village }
                                                addAttribute={ addCardholderAccessGroup }
                                                removeAttribute={ removeCardholderAccessGroup }
                                            />
                                            
                                        )
                                    }

                                    {
                                        errorMessage && <DisplayConnectionError errorMessage={ errorMessage } title={ village.villageName } />
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
        
                    }
                </>
            }
        </>
        
    );

};